// extracted by mini-css-extract-plugin
export default {"selectAllRow":"StudentListSkeleton__selectAllRow___NVSjH","skeletonRow":"StudentListSkeleton__skeletonRow___pFbxV","skeletonText":"StudentListSkeleton__skeletonText___Ko56i"};